import type { IExtractParams } from "@/routes";
import { apiPathFunc } from "@api/util/apiPathFunc";
import { states } from "@api/courses/reviews/states/path";

const pathBase = `/courses/:courseId/reviews/`;
const pathById = `${pathBase}:reviewId/`;

export type IPathBaseParam = IExtractParams<typeof pathBase>;
export type IPathByIdParam = IExtractParams<typeof pathById>;

export const reviews = {
  getAll: apiPathFunc(pathBase),
  post: apiPathFunc(pathBase),
  get: apiPathFunc(pathById),
  delete: apiPathFunc(pathById),
  states,
} as const;
